import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getJob, deleteJob } from "../../slice/workerJobSlice";
import "./style/workerListing-style.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import Pagination from "../../../../../pagination/components";

const WorkerMyJob = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const { jobData, loading, error, pagination } = useSelector(
    (state) => state.workerJob
  );
  const token = localStorage.getItem("token");
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!token) return;

    dispatch(getJob({ search, token, page }));
  }, [search, token, dispatch, page]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.last_page) {
      setPage(newPage);
    }
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "published":
        return "bg-success";
      case "draft":
        return "bg-warning text-dark";
      case "expired":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  const handleDelete = async (jobId) => {
    const confirmed = window.confirm("Are you sure you want to delete this job?");
    if (!confirmed) return;

    const result = await dispatch(deleteJob({ token, id: jobId }));

    if (result.meta.requestStatus === "fulfilled") {
      toast.success("Job deleted successfully", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
      dispatch(getJob(token)); // Refresh list
    } else {
      toast.error("Failed to delete job", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
  };


  // console.log("jobData",jobData);

  return (
    <>
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
            My Job
          </h4>

          {/* LOADING */}
          {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>}

          {/* ERROR */}
          {error && <p className="text-danger">{error}</p>}
          {!loading && !error && (
            <main className="overflow-hidden">
              <section className="pb-5">
                <div className="container">
                  <div className="form-section bg-light rounded p-3 p-sm-4">
                    {jobData.length === 0 ? (
                      <div className="text-center py-5">
                        <h5 className="text-muted">No jobs available</h5>
                      </div>
                    ) : (
                      jobData.map((job) => {
                        return (
                          <div
                            className="row"
                            style={{ cursor: "pointer" }}
                            key={job.id}
                            onClick={() => window.open(`/job-details/${job.id}`, '_blank')}
                          >
                            <div className="col-12">
                              <div className="card activity-card d-md-flex flex-md-row p-4 position-relative">

                                {/* 🔹 JOB TYPE (Top Right) */}
                                <div
                                  className="d-flex align-items-center gap-2 position-absolute"
                                  style={{ top: "15px", right: "15px", zIndex: 2 }}
                                >
                                  {/* JOB TYPE */}
                                  <span className="badge bg-info text-white">
                                    {job.job_type}
                                  </span>

                                  {/* EDIT */}
                                  <button
                                    className="btn btn-light-header"
                                    title="Edit Job"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`/panel/edit-job/${job.id}`)
                                    }}
                                  >
                                    <i className="fa fa-pencil text-light" />
                                  </button>

                                  {/* DELETE */}
                                  <button
                                    className="btn btn-light-header"
                                    title="Delete Job"
                                    onClick={(e) => {
                                      e.stopPropagation(); // ❌ Prevent row click
                                      handleDelete(job.id);
                                    }}
                                  >
                                    <i className="fa fa-trash text-light" />
                                  </button>
                                </div>

                                <div
                                  className="position-relative services-list-box"
                                  style={{
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    width: "25%",
                                  }}
                                >
                                  <a href="#" className="text-decoration-none position-absolute top-0 end-0 m-2">
                                    <i className="fa fa-heart-o text-white font-size-22" />
                                  </a>
                                </div>

                                <div className="card-body py-0 pe-0 ps-0 ps-md-4 ms-xl-1 mt-4 mt-md-0">

                                  <h6 className="font-weight-bold text-primary font-size-22 mb-2 montserrat">
                                    {job.title}
                                  </h6>

                                  {/* 🔹 STATUS HIGHLIGHT */}
                                  <div className="mb-3">
                                    <span className={`badge ${getStatusClass(job.status)} px-3 py-2 font-size-14`}>
                                      {/* <span className={`badge bg-success px-3 py-2 font-size-14`}> */}
                                      {job.status}
                                    </span>
                                  </div>

                                  <div className="text-muted font-size-14 mb-2">
                                    <strong>Min Salary:</strong> {job.salary_min}{" "}
                                    <strong>Max Salary:</strong> {job.salary_max}
                                  </div>

                                  <div className="text-muted font-size-14 mb-2">
                                    <strong>Experience Level:</strong> {job.experience_level}
                                  </div>

                                  <p dangerouslySetInnerHTML={{ __html: job.description }} />

                                  <div className="d-flex justify-content-between align-items-center mt-4">
                                    <span
                                      className="rating-badge btn btn-light-header font-size-16 rounded-pill text-white px-3 py-2"
                                      onClick={() => window.open(`/job-details/${job.id}`, "_blank")}
                                    >
                                      View Details
                                    </span>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                        );
                      })
                    )}
                  </div>
                </div>
              </section>
              <Pagination
                currentPage={page}
                totalPages={pagination.last_page || 0}
                onPageChange={handlePageChange}
              />
            </main>
          )}
        </div>
      </div>
    </>
  )
};

export default WorkerMyJob;